import theme from "@/theme";
import { SxProps, Theme } from "@mui/material";

const styles: Record<string, SxProps<Theme>> = {
  wrapper: {
    minWidth: "23.9375rem",
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
    cursor: "pointer",
    padding: "1.25rem",
    borderRadius: "16px",
    margin: "0",
    bgcolor: theme.palette.custom.mainWhite,
  },
  topRow: {
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
  },
  avatar: {
    width: 64,
    height: 64,
  },
  companyName: {
    fontSize: "0.9375rem",
    lineHeight: "160%",
    fontWeight: 600,
  },
  symbolRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  middle: {
    display: "flex",
    flexDirection: "column",
    gap: "0.25rem",
  },
  priceRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  afterHoursRow: {
    display: "flex",
    justifyContent: "space-between",
  },
  bottom: {
    display: "flex",
    alignItems: "center",
  },
  bottomInner: {
    display: "flex",
    gap: 0.5,
    alignItems: "center",
  },
  redDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    bgcolor: (theme: Theme) => theme.palette.custom.secondaryRed,
  },
};

export default styles;
